import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-y-auto px-2 py-5 no-scrollbar" }
const _hoisted_3 = {
  class: "flex-1 bg-white space-y-1",
  "aria-label": "Sidebar"
}
const _hoisted_4 = ["to", "onClick"]
const _hoisted_5 = { class: "flex-1 text-sm font-medium" }
const _hoisted_6 = {
  key: 0,
  class: "flex-1 text-sm font-medium"
}
const _hoisted_7 = {
  key: 0,
  class: "flex-1 text-sm font-medium"
}

import { ref } from "vue"
import { useRoute } from "vue-router"
import GgmsDisclosureForNavigation from "@/components/GgmsDisclosureForNavigation.vue"
import GgmsAgencySelect from "@/components/GgmsAgencySelect.vue"
import { useNavigationSidebarStore } from "@/stores/navigation-sidebar"
import { NavigationChildItem, NavigationItem } from "@/shared/models/navigation"

interface Props {
    items: NavigationItem[]
    collapsed: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsNavigation',
  props: {
    items: {},
    collapsed: { type: Boolean }
  },
  emits: ["menuItemClick"],
  setup(__props: any, { emit: __emit }) {

const route = useRoute()

const navigationSidebarStore = useNavigationSidebarStore()

const props = __props

const emit = __emit

const collapsed = ref(props.collapsed)

const disclosures = ref([] as any[])

function getParentIconClass(isOpen: boolean) {
    return isOpen ? "stroke-primary-color-600" : "stroke-gray-400 group-hover:stroke-gray-500"
}

function getParentIconStroke(isOpen: boolean) {
    return isOpen ? "stroke-primary-color-600" : "stroke-gray-400 group-hover:stroke-gray-500"
}

function getParentTextClass(isOpen: boolean) {
    return isOpen ? "text-primary-color-600" : ""
}

function changeCollapsedState(collapsedValue: boolean) {
    collapsed.value = collapsedValue
}

function getClassesItem(item: NavigationItem) {
    return [
        checkActiveRoute(item.path as string)
            ? "bg-primary-color-600 text-white hover:bg-primary-color-700"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
        "group flex items-center text-sm font-medium rounded-md",
    ]
}

function getClassesChildItem(item: NavigationChildItem) {
    return [
        checkActiveRoute(item.path as string)
            ? "bg-primary-color-600 text-white hover:bg-primary-color-700"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
        "group flex items-center px-10 py-2 text-sm font-medium rounded-md",
    ]
}

function getClassesIcon(item: NavigationItem) {
    return [
        checkActiveRoute(item.path as string) ? "text-white" : "text-gray-400 group-hover:text-gray-500",
        "mr-3 flex-shrink-0 h-6 w-6",
    ]
}

function checkActiveRoute(path: string) {
    return route.path === path || route.path.includes(path)
}

function closeDisclosure(index?: number) {
    navigationSidebarStore.toggleSidebar(false)
    disclosures.value.forEach((disclosure, disclosureIndex) => {
        if (disclosureIndex === index) {
            return
        }
        disclosure?.closeDisclosure()
    })
}

function onItemClick(item: NavigationItem) {
    if (!props.collapsed) return
    emit("menuItemClick", item)
}

function getItemPath(item: NavigationItem) {
    return item?.path || ""
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GgmsAgencySelect, {
        collapsed: props.collapsed
      }, null, 8, ["collapsed"]),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            to: item.path,
            class: _normalizeClass(getClassesItem(item)),
            onClick: ($event: any) => (onItemClick(item)),
            role: "button"
          }, [
            (item.children && !props.collapsed)
              ? (_openBlock(), _createBlock(GgmsDisclosureForNavigation, {
                  key: item.name,
                  ref_for: true,
                  ref: (el) => (disclosures.value[index] = el),
                  "children-items": item.children,
                  name: item.name,
                  class: "flex w-full space-y-1"
                }, {
                  header: _withCtx(({ isOpen }) => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass([getClassesIcon(item), getParentIconClass(isOpen)]),
                      stroke: getParentIconStroke(isOpen),
                      "aria-hidden": "true"
                    }, null, 8, ["class", "stroke"])),
                    (!props.collapsed)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["flex-1 self-center text-sm font-medium", getParentTextClass(isOpen)])
                        }, _toDisplayString(item.name), 3))
                      : _createCommentVNode("", true)
                  ]),
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: child.path,
                        key: child.name,
                        class: _normalizeClass(getClassesChildItem(child)),
                        onClick: ($event: any) => (closeDisclosure(index))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["children-items", "name"]))
              : (!item.children && !props.collapsed)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: getItemPath(item),
                    class: _normalizeClass([
                            'flex',
                            'w-full',
                            'items-center',
                            'py-2',
                            props.collapsed ? 'px-3' : 'px-2',
                            'lg:px-3',
                            '2xl:px-3',
                        ]),
                    onClick: closeDisclosure
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        class: _normalizeClass([
                                'flex-shrink-0 h-6 w-6 mx-auto',
                                props.collapsed ? 'block' : 'mr-3',
                                getClassesIcon(item),
                            ]),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])),
                      (!props.collapsed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: getItemPath(item),
                    class: _normalizeClass([
                            'flex',
                            'w-full',
                            'items-center',
                            'py-2',
                            props.collapsed ? 'px-3' : 'px-2',
                            'lg:px-3',
                            '2xl:px-3',
                        ]),
                    onClick: closeDisclosure
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                        class: _normalizeClass([
                                'flex-shrink-0 h-6 w-6 mx-auto',
                                props.collapsed ? 'block' : 'mr-3',
                                getClassesIcon(item),
                            ]),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])),
                      (!props.collapsed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])), [
                    [
                      _directive_tooltip,
                      { value: item.name, class: 'font-medium text-xs  px-3 py-2' },
                      void 0,
                      { right: true }
                    ]
                  ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})